import * as THREE from "three";

import Representation3d from "../representation3d/Representation3d";
import ProductData from "../productData/ProductData";
import MaterialPair from "../material/MaterialPair";
import { getLayerForProductRepresentation3d } from "../../utils/layerUtils";
import Representation3dTypeEnum from "../representation3d/Representation3dTypeEnum";
import TriangleMeshGeometry from "../geometry/TriangleMeshGeometry";
import TriangleMesh from "../representation3d/TriangleMesh";
import ExtrudedAreaSolidGeometry from "../geometry/ExtrudedAreaSolidGeometry";
import ExtrudedAreaSolid from "../representation3d/ExtrudedAreaSolid";
import FbxAsset from "../representation3d/FbxAsset";
import FbxAsyncGeometry from "../geometry/FbxAsyncGeometry";
import IProduct from "../../interfaces/IProduct";
import { USE_SHADOWS } from "../../components/Stage3d";
import { ElementTypeEnum } from "../../elementTypeMappings";
import CoveringData from "../productData/CoveringData";
import IfcCoveringTypeEnum from "../../enums/IfcCoveringTypeEnum";

// Floor and ceiling coverings take their texture direction from their local X axis
const isHorizontalCovering = (product: IProduct) : boolean => {
    if (product.productData.productType != ElementTypeEnum.Covering) return false;
    const coveringType = (product.productData as CoveringData).coveringType;
    return coveringType == IfcCoveringTypeEnum.FLOORING || coveringType == IfcCoveringTypeEnum.CEILING;
};

const createProductRepresentation3d = ( representation3d : Representation3d, 
                                        product: IProduct, 
                                        materialPair: MaterialPair) : THREE.Object3D | null => {
    
    const layer = getLayerForProductRepresentation3d(   product.productData.productType, 
                                                        representation3d.representationType, 
                                                        product.productData);

    let representationObject: THREE.Object3D | null = null;
    const material = materialPair.getThreeJsMaterial(isHorizontalCovering(product));

    switch (representation3d.representationType) {
        case Representation3dTypeEnum.TriangleMesh:
            representationObject = TriangleMeshGeometry.create( representation3d as TriangleMesh, 
                                                material, 
                                                layer);
            break;

        case Representation3dTypeEnum.ExtrudedAreaSolid:

            const eas = representation3d as ExtrudedAreaSolid;
            representationObject = ExtrudedAreaSolidGeometry.create( eas, 
                                                        material, 
                                                        layer);
            break;
        
        case Representation3dTypeEnum.FbxAsset:
            const fbxRepr = representation3d as FbxAsset;
            const fbxGeom = new FbxAsyncGeometry(   fbxRepr.path, 
                                                    layer, 
                                                    fbxRepr.placement.location,
                                                    product.dimensions,
                                                    {
                                                        scaleToFit: fbxRepr.scaleToFit,
                                                        isMirrored: fbxRepr.isMirrored,
                                                        rotation: fbxRepr.placement.getRotationQuaternion()
                                                    }
                                                );
            representationObject = fbxGeom.group;
            break;

        case Representation3dTypeEnum.NotDefined:
        default:
            return null;

    }

    if (USE_SHADOWS) {
      representationObject?.traverse((child: THREE.Object3D) => {
          if (child instanceof THREE.Mesh) {
              child.castShadow = true;
              child.receiveShadow = true;
          }
      });
    }
    
    return representationObject;
};

export { createProductRepresentation3d };

